import { FieldFormat, SectionConfig } from "../../types";
import { selectActionStep } from "../selectors";
import { getItemKeyByValue } from "./helpers";

const CONTENT_TYPE: FieldFormat = {
  enum: {
    PDF: "emailBodyInPdf",
    ATTACHMENTS: "attachments",
    EML: "ruleAction.saveFormat.eml",
    MSG: "ruleAction.saveFormat.msg",
    ORIGINAL: "ruleAction.saveFormat.original",
  },
};

// Reusable enum value → i18n key maps (the same labels the form shows).
const LINKS_FORMAT: FieldFormat = {
  enum: { PDF: "attachmentPdf", LINK: "emailsBody", BOTH: "common:both" },
};

const config: SectionConfig = {
  section: "actionStep",
  titleKey: "confirmRuleUpdates.actionStepChanges.title",
  selector: selectActionStep,
  properties: {
    contentTypes: {
      label: "confirmRuleUpdates.actionStepChanges.contentType",
      format: CONTENT_TYPE,
      getItemKey: getItemKeyByValue,
    },
    linksFormat: {
      label: "confirmRuleUpdates.actionStepChanges.linksFormat",
      format: LINKS_FORMAT,
    },
    storageNotificationTemplateId: {
      label: "storageNotificationTemplate.label",
      format: { resolve: "template" },
    },
    passwordNotificationToRecipient: {
      label: "zipPassword.sendToRecipient.label",
      format: "boolean",
    },
    passwordNotificationToSender: {
      label: "zipPassword.sendToSender.label",
      format: "boolean",
    },
    blockTitle: { label: "confirmRuleUpdates.actionStepChanges.blockTitle" },
    blockBodyText: {
      label: "confirmRuleUpdates.actionStepChanges.blockBodyText",
    },
    senderTitle: { label: "senderNotification.title.label" },
    senderBodyText: { label: "senderNotification.bodyText.label" },
    passwordRecipientLineText: {
      label: "passwordNotifications.recipientLineText.label",
    },
    passwordSubjectTag: { label: "passwordNotifications.subjectTag.label" },
    passwordSenderLineText: {
      label: "passwordNotifications.senderLineText.label",
    },
    passwordSenderAllLineText: {
      label: "passwordNotifications.senderAllLineText.label",
    },
  },
};

export default config;
